












































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import Draggable from 'vuedraggable'

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import {
  IWorkflowsInputModifyJobs,
  IWorkflowsInputModifyJobsJob,
} from '@/api/types/request.types'
import { IJobAssigneeMandate } from '@/api/types/response.types'
import { EEntities } from '@/types'

/* API */
import WorkflowsAPI from '@/api/modules/workflows.api'

export default Vue.extend({
  name: 'ManageJobsDrawer',

  components: {
    Draggable,
  },

  props: {
    workflowId: {
      type: Number,
      required: true,
    },
    jobs: {
      type: Array as () => IWorkflowsInputModifyJobsJob[],
      required: true,
    },
    assigneeMandates: {
      type: Array as () => IJobAssigneeMandate[],
      required: true,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    showDrawer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      TextAssistant,
      maxJobsAllowed: 10,
      isUpdatingJobs: false,
      internalJobs: [] as IWorkflowsInputModifyJobsJob[],
    }
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isMobile(this.$mq)) {
        return '100%'
      }
      return '680px'
    },
    btnColor(): string {
      return ColorAssistant.getEntityColor(this.entityType)
    },
    itemTypeNameSingular(): string {
      return TextAssistant.itemSingularName(this.entityType)
    },
    itemTypeNamePlural(): string {
      return TextAssistant.itemPluralName(this.entityType)
    },
    entityTypeNameSingular(): string {
      return TextAssistant.entitySingularName(this.entityType)
    },
  },

  watch: {
    jobs: {
      immediate: true,
      handler(val: IWorkflowsInputModifyJobsJob[]) {
        this.internalJobs = []
        val.forEach(j => {
          this.internalJobs.push({
            id: j.id,
            name: j.name,
          })
        })
      },
    },
  },

  created() {},

  methods: {
    hasAssigneeMandate(job: IWorkflowsInputModifyJobsJob): boolean {
      return this.assigneeMandates.some(am => am.jobID === job.id)
    },
    removeJob(index: number) {
      this.internalJobs.splice(index, 1)
    },
    addAdditionalJob() {
      this.internalJobs.push({
        id: null,
        name: '',
      })
    },
    async updateJobs() {
      try {
        this.isUpdatingJobs = true
        const data = {
          listJobs: this.internalJobs,
        } as IWorkflowsInputModifyJobs

        const response = await WorkflowsAPI.put_ModifyJobs(
          this.workflowId,
          data,
        )
        this.$emit('jobs-updated')
        this.visible = false
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isUpdatingJobs = false
      }
    },
  },
})
